// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"_i-z"};